// import axios from 'axios';
// import config from '@assets/config.json'; // api 请求json 

const state = {
    activeIndex: -1, // 自定义组件当前激活索引
    currentSave: false, // 组件保存选项
    destroy: false, // 判断销毁poper
    load: false, 
    commmonArr: [ // 通用组件数组
        {
            title: "文本",
            icon: "icon-wenbenbianji",
            type: "text",
            componentName: "customText",
            config: {
                type: 1, // 文本类型 暂时只有 1
                content: "", // 文本内容
                fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
                color: "#000", // 文字颜色 默认黑色
                position: "left" // 文本对齐格式
            }
        },
        {
            title: "图片",
            icon: "icon-shangchuantupian",
            type: "picture",
            componentName: "customPicture",
            config: {
                type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
                padding: 0, // 页面边距
                spacing: 0, // 图片边距
                list: [
                    {
                        url: "",
                        title: "",
                        link: {
                            type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                            value: ""
                        }
                    }
                ]
            }
        },
        {
            title: "标题",
            icon: "icon-biaoti",
            type: "title",
            componentName: "customTitle",
            config: {
                type: 1, // 标题类型 暂时只有 1
                content: "",
                position: "left", // 文本对齐格式
                padding: "3px", // 标题的边距
                fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
                color: "#000", // 文字颜色
                link: {
                    type: "0",
                    value: ""
                }
            }
        },
        {
            title: "链接",
            icon: "icon-link",
            type: "link",
            componentName: "customLink",
            config: {
                type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                name: "",
                url: ""
            }
        },
        {
            title: "产品搜索",
            icon: "icon-sousuo",
            type: "search",
            componentName: "customSearch",
            config: {
                type: 1, // 搜索类型 暂时只有 1
                words: [],
                style: "circular", // 搜索外边框样式 （圆 \ 方）
                position: "left", // 文本对齐格式
                color: "#ccc",
                background: "#f5f5f5",
                borderColor: "#91c0ec"
            }
        },
        {
            title: "视频",
            icon: "icon-shangchuanshipin",
            type: "video",
            componentName: "customVideo",
            config: {
                type: 1, // 视频类型 暂时只有 1
                cover: "", // 封面
                time: 5000, // 视频封面截取帧
                link: "", // 视频地址
                coverType: "0" // 视频封面累心 0 截取 1 自定义
            }
        }
    ],
    commmonArr2: [ // 通用组件数组2 
        {
            title: "文本",
            icon: "icon-wenbenbianji",
            type: "text",
            componentName: "customText",
            config: {
                type: 1, // 文本类型 暂时只有 1
                content: "", // 文本内容
                fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
                color: "#000", // 文字颜色 默认黑色
                position: "left" // 文本对齐格式
            }
        },
        {
            title: "图片",
            icon: "icon-shangchuantupian",
            type: "picture",
            componentName: "customPicture",
            config: {
                type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
                padding: 0, // 页面边距
                spacing: 0, // 图片边距
                list: [
                    {
                        url: "",
                        title: "",
                        link: {
                            type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                            value: ""
                        }
                    }
                ]
            }
        },
        {
            title: "视频",
            icon: "icon-shangchuanshipin",
            type: "video",
            componentName: "customVideo",
            config: {
                type: 1, // 视频类型 暂时只有 1
                cover: "", // 封面
                time: 5000, // 视频封面截取帧
                link: "", // 视频地址
                coverType: "0" // 视频封面累心 0 截取 1 自定义
            }
        }
    ],
    save: false,
}
const mutations = {
    setActiveIndex(state, data) {
        state.activeIndex = data;
    },
    setCurrent(state, data) {
        state.currentSave = data;
    },
    setDestroy(state, data) {
        state.destroy = data;
    },
    setSave(state, data) {
        state.save = data;
    },
    setLoad(state, data) {
        state.load = data;
    },
}
const getters = {
    getActiveIndex: state => {
        return state.activeIndex;
    },
    getCurrent: state => {
        return state.currentSave;
    },
    getDestroy: state => {
        return state.destroy;
    },
    getDefaultArr: state => {
        return state.defaultArr;
    },
    getSave: state => {
        return state.save;
    },
    getLoad: state => {
        return state.load;
    },
}
const actions = {
    transformCustomData({ }, opt) { // 转化自定义组件的数据 - 获取转化
        let data = [];
        opt.forEach((c, i) => {
            let keys = Object.keys(c); 
            if (keys[0] === 'text') {
                data.push({
                    title: "文本",
                    icon: "icon-wenbenbianji",
                    type: "text",
                    componentName: "customText",
                    config: opt[i]['text']
                });  
            }
            if (keys[0] === 'picture') {
                data.push({
                    title: "图片",
                    icon: "icon-shangchuantupian",
                    type: "picture",
                    componentName: "customPicture",
                    config: opt[i]['picture']
                });
            }
            if (keys[0] === 'title') {
                data.push({
                    title: "标题",
                    icon: "icon-biaoti",
                    type: "title",
                    componentName: "customTitle",
                    config: opt[i]['title']
                });

            }
            if (keys[0] === 'link') {
                data.push({
                    title: "链接",
                    icon: "icon-link",
                    type: "link",
                    componentName: "customLink",
                    config: opt[i]['link']
                });

            }
            if (keys[0] === 'search') {
                data.push({
                    title: "产品搜索",
                    icon: "icon-sousuo",
                    type: "search",
                    componentName: "customSearch",
                    config: opt[i]['search']
                });
            }
            if (keys[0] === 'video') {
                data.push({
                    title: "视频",
                    icon: "icon-shangchuanshipin",
                    type: "video",
                    componentName: "customVideo",
                    config: opt[i]['video']
                });

            }
        }); 
        return new Promise((resolve, reject) => {
            resolve(data);
        });
    },
    transformReqCustomData({ }, opt) { // 转化自定义组件的数据 - 提交转化
        let data = [];
        opt.forEach(c => {
            data.push({ [c.type]: c.config });
        });   
        return new Promise((resolve, reject) => {
            resolve(JSON.stringify(data));
        });
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
} 